// extracted by mini-css-extract-plugin
module.exports = {"base":"_1H61N"};